interface FinishPriceProps {
  discountedAmount: number;
  showOldPrice: boolean;
  oldPriceAmount: number;
  priceAmount: number;
}

export const getFinishPrice = ({
  discountedAmount,
  showOldPrice,
  oldPriceAmount,
  priceAmount,
}: FinishPriceProps): {
  discount: number;
  originalPrice: number;
} => {
  const isDiscount = priceAmount - discountedAmount > 0;
  //TODO: GROW-1607 Refactor after all gen3 rings sell out
  let originalPrice = oldPriceAmount;
  if (isDiscount && !showOldPrice) {
    originalPrice = priceAmount;
  }

  const discount = originalPrice - discountedAmount;
  return {
    discount,
    originalPrice,
  };
};
